import { closeDrawerPane, hasActiveDrawerPane } from 'owa-drawer';
import { flexPaneClosed } from 'owa-suite-header-apis';
import { setIsFlexPaneShown } from 'owa-suite-header-store';
import { triggerResizeEvent } from 'owa-resize-event';

export default function closeHeaderPane(
    paneId: string,
    targetWindow?: Window,
    wasDrawerPaneClosed?: boolean
): void {
    const paneClosed = closeDrawerPane(
        paneId,
        targetWindow,
        false /* do not dispatch close action */
    );
    flexPaneClosed(paneId);

    if (paneClosed || (wasDrawerPaneClosed && !hasActiveDrawerPane(targetWindow))) {
        setIsFlexPaneShown(paneId, false);
        triggerResizeEvent();
    }
}
